import type { EChartsOption } from "echarts"

export default {
  color: ["#6192E9", "#57CCA1", "#EEBD45", "#DC7378", "#2BB7F7", "#AE59F0"],
  legend: {
    left: "0",
    top: "center",
    origin: "vertical",
    formatter: "{name}",
    icon: "circle",
    width: 10,
    textStyle: {
      color: "#FFF",
    },
  },
  title: {
    show: false,
  },
  series: [
    {
      name: "main",
      type: "pie",
      radius: ["60%", "75%"],
      center: ["75%", "center"],
      avoidLabelOverlap: false,
      itemStyle: {
        borderRadius: 2,
        borderColor: "rgba(29, 45, 73)",
        borderWidth: 2,
      },
      label: {
        show: false,
      },
      emphasis: {
        label: {
          show: false,
        },
      },
      labelLine: {
        show: false,
      },
      data: [],
    },
  ],
  graphic: [{}],
} as EChartsOption
